import VocLayoutBasic from "./src/main"

/* istanbul ignore next */
VocLayoutBasic.install = function (Vue) {
  Vue.component(VocLayoutBasic.name, VocLayoutBasic)
}

export default VocLayoutBasic
